import { useContext, useState } from 'react'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { descriptografarDado } from '../../helpers'
import { toast } from 'react-toastify'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import Permissoes from '../../middleware/Permissoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import '../../styles/menuopcoes.css'

function MenuConfiguracao(props: menuOpcoes) {

    const [subMenu, setSubMenu] = useState(false)

    const { modalExibir } = useContext(ModalEstadoContext)

    function exibirSubmenu() {
        setSubMenu(subMenu => !subMenu)
    }

    function exibirModalMinhaAssinatura() {
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'configuracao_assinatura']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para acessar as assinaturas da plataforma.")
        modalExibir('minhaAssinatura')
    }

    return (
        <Permissoes permissoes={['master', 'administrativo', 'configuracao_acesso']}>
            <div>
                <div id='menuOpcoes' onClick={exibirSubmenu}>
                    {<img id='iconeMenu' src={props.icone} alt={props.alt}></img>}
                    <p id='tituloMenu'>{props.titulo}</p>
                </div>
                <div id='submenuOpcoes'>
                    <Permissoes permissoes={['master', 'administrativo', 'configuracao_empresa']}>
                        {subMenu && <SubMenuOpcoes redirect='/organizacao' texto='Dados da Empresa' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'configuracao_assinatura']}>
                        {subMenu && <SubMenuOpcoes redirect='#' texto='Minha Assinatura' acao={exibirModalMinhaAssinatura} />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'configuracao_usuario']}>
                        {subMenu && <SubMenuOpcoes redirect='/usuarios' texto='Usuários' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'configuracao_integracao']}>
                        {subMenu && <SubMenuOpcoes redirect='/integracoes' texto='Integrações' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'configuracao_grupos_permissao']}>
                        {subMenu && <SubMenuOpcoes redirect='/grupos-permissoes' texto='Grupos e Permissoes' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'configuracao_centro']}>
                        {subMenu && <SubMenuOpcoes redirect='/centros' texto='Centro de Resultado/Custo' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'configuracao_plano_conta']}>
                        {subMenu && <SubMenuOpcoes redirect='/categorias' texto='Plano de Contas' />}
                    </Permissoes>
                </div>
            </div>
        </Permissoes>
    )
}

export default MenuConfiguracao